
export class MonthlyScheduleRecord {
    _WorkflowTask_key?: number;
    TaskName: string;
    TaskType: string;
    ResourceName?: string;
    ResourceGrouped?: string;
    ResourceBackgroundColor?: string;
    ResourceForegroundColor?: string;
    DateStart?: Date;
    DateEnd?: Date;
    TaskCount?: number;
    AnimalCount?: number;
    CurrentLocationPath?: string;
    JobID?: string;
}
